import React, { useEffect } from "react";
import { Kleisli, useKleisli } from "./use.kleisli";
import { isDataAs, isErrorAs, isLoadingAs } from "./async.state";

export type LoadingOrErrorFnProps = {
    error: string;
}
export type LoadingOrErrorFn = (props: LoadingOrErrorFnProps) => React.ReactElement;

export type LoadingOrProps<Input, Output> = {
    input: Input;
    kleisli: Kleisli<Input, Output>;
    loading?: () => React.ReactNode;
    error?: LoadingOrErrorFn;
    onUnmount?: (output: Output) => void;
    children: (output: Output) => React.ReactNode;
}

export function defaultLoading(): React.ReactElement {
    return <div>Loading...</div>;
}


export const defaultError: LoadingOrErrorFn = ({ error }): React.ReactElement =>
    <div>Error: {error}</div>;

export function LoadingOr<Input, Output>({ input, kleisli, loading = defaultLoading, error = defaultError, children, onUnmount = () => {} }: LoadingOrProps<Input, Output>): React.ReactNode {
    const state = useKleisli<Input, Output>(kleisli, input);
    useEffect(() => {
        return () => {if (isDataAs(state)) onUnmount(state.data as Output);};
    }, [state, onUnmount]);
    if (isLoadingAs(state)) return loading!();
    if (isErrorAs(state)) return error!({ error: state.errors.join(",") });
    if (isDataAs(state)) return children!(state.data as Output);
    console.error("This should never happen: state is in an invalid state", state);
    return <></>;
}